import React from 'react';
import { Zap, Play } from 'lucide-react';
import Container from '../ui/Container';
import Button from '../ui/Button';
import { getTgLink } from '../../utils/telegram';

const Hero: React.FC = () => (
  <section className="relative h-screen w-full flex items-center overflow-hidden sticky top-0">
    <div className="absolute inset-0 z-0">
      <img 
        src="/images/hero/hero.png" 
        alt="Dance vibe" 
        className="w-full h-full object-cover object-center"
      />
    </div>

    <div className="w-full max-w-[1920px] mx-auto px-4 md:px-8 lg:px-12 xl:px-16 2xl:px-32 relative z-10">
      <div className="h-full flex items-center">
        {/* Адаптивная ширина с учетом сетки: на мобильных - 100%, на десктопе - 50% минус gap */}
        <div className="w-full md:w-[calc(50%-10px)] lg:w-[calc(50%-12px)] xl:w-[calc(50%-16px)] 2xl:w-[calc(50%-20px)]">
          {/* Контейнер для заголовка и подзаголовка */}
          <div className="mb-8">
            <h1 className="display-xl text-brand-white leading-[0.9] mb-4 tracking-tight">
              Танцуй уверенно уже с первого дня
            </h1>
            <p className="body-lg text-brand-white/50 leading-relaxed font-medium">
              Забудь про стеснение! Студия танцев в Омске, где результат виден с первого занятия!
            </p>
          </div>

          {/* Кнопки */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              href={getTgLink("Привет! Хочу записаться на занятия!")}
            >
              Записаться бесплатно
            </Button>
            <Button 
              variant="secondary"
              href={getTgLink("Привет! Хочу забрать мини-курс")}
            >
              Смотреть мини-курс
            </Button>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;